import { DashboardMode } from '@shared/enums/dashboard-mode';
import { UserData } from '@shared/interfaces/user-data';

export function getDashboardMode(userData: UserData): DashboardMode {
  // TODO Add Administrator general roles handling when available
  if (userData.generalRole === 'Asset Manager') {
    return DashboardMode.ASSET_MANAGER;
  }
  if (userData.generalRole === 'SuperUser') {
    // return DashboardMode.SUPER_USER;
    return DashboardMode.ASSET_MANAGER;
  }

  return DashboardMode.PROPERTY_MANAGER;
}
